import { useCallback } from "react";
import {
  useLocation,
  useNavigate,
  type NavigateFunction,
  type NavigateOptions,
  type To,
} from "react-router-dom";
import { appPath } from "@/lib/app-version";

export function useAppPath(): (path: string) => string {
  const { pathname } = useLocation();
  return useCallback((path: string) => appPath(path, pathname), [pathname]);
}

export function useAppNavigate(): NavigateFunction {
  const navigate = useNavigate();
  const path = useAppPath();
  return useCallback(
    (to: To | number, options?: NavigateOptions) => {
      if (typeof to === "number") return navigate(to);
      return navigate(
        typeof to === "string"
          ? path(to)
          : {
              ...to,
              pathname:
                to.pathname === undefined ? undefined : path(to.pathname),
            },
        options,
      );
    },
    [navigate, path],
  ) as NavigateFunction;
}
